import React, { Component } from 'react';
import routes from './Routes';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import fetch from './interceptor/fetch';


class App extends Component  {
  render() {
    const RouteWithSubRoutes = (route) => (
     <Route path={route.path} exact={route.exact} key={`route${route.path}`} render={(props) =>(
      <route.component {...props} routes={route.routes} />
     )
    }/>
    )
   
  return (
    <Router>
      <Switch>
        {
         routes.map (
          (route) => (
           <RouteWithSubRoutes key={route.path} {...route} exact /> 
          ))
        }
      </Switch>
    </Router>

  );
}
}

export default App;